import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IJadai, IJadaiInitialState } from "./jadaiModel";
import {
  createJadai,
  deleteJadai,
  deleteJadaiApprovalItem,
  deleteJadaiEntryItems,
  deleteJadaiOrderItems,
  findAllJadai,
  getJadaiById,
  updateJadai,
} from "./services/jadai.services";

const initialState: IJadaiInitialState = {
  loading: false,
  error: "",
  JadaiID: null,
  JadaiList: [],
  JadaiDetail: {
    issue_date: new Date(),
    issue_no: null,
    approx_delivery_date: "",
    karigar_id: null,
    given_amount: null,
    remarks: "",
    jadai_order: [],
    jadai_Entry_item: [],
  },
  FilterJadai: {
    karigar_name: "",
    karigar_nick_name: "",
    issue_date: "",
    approx_delivery_date: "",
  },
  JadaiOrderItemIndex: -1,
  JadaiEntryItemIndex: -1,
  JadaiApprovalItemIndex: -1,
  JadaiOrderSelectionDialog: false,
  JadaiApprovalItemDeleteDialog: false,
  JadaiViewImageDialog: false,
  JadaiOrderSave: false,
  JadaiSelectOrderItemIndex: -1,
  JadaiPreviousOrder: null,
};

const jadaiSlice = createSlice({
  name: "jadai",
  initialState,
  reducers: {
    clearJadaiDetail: (state) => {
      state.JadaiDetail = initialState.JadaiDetail;
    },
    setJadaiID: (state, action) => {
      state.JadaiID = action.payload;
    },
    setFilterJadai: (state, action) => {
      state.FilterJadai = action.payload;
    },
    setJadaiOrderSave: (state, action) => {
      state.JadaiOrderSave = action.payload;
    },
    clearFilterJadai: (state) => {
      state.FilterJadai = initialState.FilterJadai;
    },
    setJadaiPreviousOrder: (state, action) => {
      state.JadaiPreviousOrder = action.payload;
    },

    setJadaiOrderItemIndex: (state, action) => {
      state.JadaiOrderItemIndex = action.payload;
    },
    setJadaiEntryItemIndex: (state, action) => {
      state.JadaiEntryItemIndex = action.payload;
    },
    setJadaiApprovalItemIndex: (state, action) => {
      state.JadaiApprovalItemIndex = action.payload;
    },
    setJadaiSelectOrderItemIndex: (state, action) => {
      state.JadaiSelectOrderItemIndex = action.payload;
    },

    openJadaiOrderSelectionDialog: (state) => {
      state.JadaiOrderSelectionDialog = true;
    },
    closeJadaiOrderSelectionDialog: (state) => {
      state.JadaiOrderSelectionDialog = false;
    },
    openJadaiApprovalItemDeleteDialog: (state) => {
      state.JadaiApprovalItemDeleteDialog = true;
    },
    closeJadaiApprovalItemDeleteDialog: (state) => {
      state.JadaiApprovalItemDeleteDialog = false;
    },
    openJadaiViewImageDialog: (state) => {
      state.JadaiViewImageDialog = true;
    },
    closeJadaiViewImageDialog: (state) => {
      state.JadaiViewImageDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllJadai.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllJadai.fulfilled,
      (state, action: PayloadAction<IJadai[]>) => {
        state.loading = false;
        state.JadaiList = action.payload || [];
      }
    );
    builder.addCase(findAllJadai.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.JadaiList = [];
    });

    builder.addCase(createJadai.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createJadai.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createJadai.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateJadai.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateJadai.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateJadai.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteJadai.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteJadai.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteJadai.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getJadaiById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getJadaiById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.JadaiDetail = action.payload;
    });
    builder.addCase(getJadaiById.rejected, (state, action) => {
      state.loading = false;
      state.JadaiDetail = initialState.JadaiDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteJadaiOrderItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteJadaiOrderItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteJadaiOrderItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteJadaiApprovalItem.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteJadaiApprovalItem.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteJadaiApprovalItem.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteJadaiEntryItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteJadaiEntryItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteJadaiEntryItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearFilterJadai,
  clearJadaiDetail,
  closeJadaiApprovalItemDeleteDialog,
  closeJadaiOrderSelectionDialog,
  closeJadaiViewImageDialog,
  openJadaiApprovalItemDeleteDialog,
  openJadaiOrderSelectionDialog,
  openJadaiViewImageDialog,
  setFilterJadai,
  setJadaiApprovalItemIndex,
  setJadaiEntryItemIndex,
  setJadaiID,
  setJadaiOrderItemIndex,
  setJadaiSelectOrderItemIndex,
  setJadaiOrderSave,
  setJadaiPreviousOrder,
} = jadaiSlice.actions;
export default jadaiSlice.reducer;
